<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-btn
                    color="indigo"
                    class="white--text"
                    :to="{ name: 'planPackages.create' }"
                >
                    <v-icon left>mdi-plus</v-icon>
                    {{
                        $t('resources.default.add', {
                            resource: $tc('resources.planPackage.name', 1),
                        })
                    }}
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <sarala-table :model="model" ref="table" :sort="sort">
                    <template #available_for_selection="{ item }">
                        {{
                            item.available_for_selection
                                ? $t('resources.default.yes')
                                : $t('resources.default.no')
                        }}
                    </template>
                </sarala-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import PlanPackage from '@/models/plans/PlanPackage'

export default {
    components: {
        'sarala-table': SaralaTable,
    },

    data: () => ({
        sort: {
            sortDesc: true,
            prop: 'channel',
        },
    }),

    computed: {
        model() {
            return new PlanPackage()
        },
    },
}
</script>
